export default "__VITE_ASSET__umP3M7kv__"